// extracted by mini-css-extract-plugin
module.exports = {"product-edit-button":"product-edit-button--j4r5z","product-edit-button--nopadding":"product-edit-button--nopadding--j4r5z"};